import { render, staticRenderFns } from "./RoleSelection.modal.vue?vue&type=template&id=3a0336a2&scoped=true"
import script from "./RoleSelection.modal.vue?vue&type=script&lang=ts"
export * from "./RoleSelection.modal.vue?vue&type=script&lang=ts"
import style0 from "./RoleSelection.modal.vue?vue&type=style&index=0&id=3a0336a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0336a2",
  null
  
)

export default component.exports